var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.904 17.071a1.25 1.25 0 0 0 1.768 0l5.156-5.156a.21.21 0 0 1 .295 0l5.156 5.156a1.25 1.25 0 1 0 1.768-1.768l-5.157-5.156a.21.21 0 0 1 0-.294l5.157-5.156a1.25 1.25 0 0 0-1.768-1.768l-5.156 5.156a.21.21 0 0 1-.295 0L4.672 2.929a1.25 1.25 0 1 0-1.768 1.768L8.06 9.853a.21.21 0 0 1 0 .294l-5.156 5.156a1.25 1.25 0 0 0 0 1.768"
  })));
};
export default SvgCross;